import * as React from 'react';

import { SvgIcon, ISvgIconProps } from 'src/widgets/Icon';

const MovieIcon = React.memo((props: ISvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </SvgIcon>
));

export { MovieIcon };
